import { KeyboardEventPredicate } from "@imi/ui/hooks/useKeyboard.js";
import { Key } from "react";
import { isMac } from "./platform";

type Identifiable<K extends Key> = {
  id: K;
};

type KeyboardModifiers = {
  altKey: boolean;
  ctrlKey: boolean;
  isComposing: boolean;
  repeat: boolean;
  shiftKey: boolean;
};

type ShortcutKey =
  | "0"
  | "1"
  | "2"
  | "3"
  | "4"
  | "5"
  | "6"
  | "7"
  | "8"
  | "9"
  | "a"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "b"
  | "c"
  | "d"
  | "e"
  | "Enter"
  | "Escape"
  | "f"
  | "g"
  | "h"
  | "i"
  | "j"
  | "k"
  | "l"
  | "m"
  | "n"
  | "o"
  | "p"
  | "q"
  | "r"
  | "s"
  | "t"
  | "u"
  | "v"
  | "w"
  | "x"
  | "y"
  | "z";

export function byId<T extends Identifiable<K>, K extends Key>(id: K) {
  return (arg: T) => arg.id === id;
}

export function byShortcut(
  key: ShortcutKey,
  modifiers?: Partial<KeyboardModifiers>,
): KeyboardEventPredicate {
  return (e: KeyboardEvent) => {
    if (key !== undefined && e.key !== key) {
      return false;
    }

    if (modifiers?.altKey && !e.altKey) {
      return false;
    }

    if (modifiers?.ctrlKey && (isMac() ? !e.metaKey : !e.ctrlKey)) {
      return false;
    }

    if (modifiers?.isComposing && !e.isComposing) {
      return false;
    }

    if (modifiers?.repeat && !e.repeat) {
      return false;
    }

    if (modifiers?.shiftKey && !e.shiftKey) {
      return false;
    }

    return true;
  };
}
